"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_token_lib_1 = require("trade_token_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeTypeDef_1 = require("../../ExchangeAPIAdapter/TradeTypeDef");
const DWUtils_1 = require("../../Tools/DWUtils");
const coinProtocols = {
    "BTC-MAINNET": "Bitcoin",
    ERC20: "Ethereum (ERC20)",
    "ETH-MAINNET": "Ethereum (ERC20)",
    BEP20: "BNB Smart Chain (BEP20)",
    "BEP20(BSC)": "BNB Smart Chain (BEP20)",
    "ADA-MAINNET": "Cardano",
    "ALGO-MAINNET": "Algorand",
    "APT-MAINNET": "APT",
    "ATOM-MAINNET": "Cosmos",
    "BCH-MAINNET": "Bitcoin Cash",
    BEP2: "BNB Beacon Chain (BEP2)",
    "BSV-MAINNET": "Bitcoin SV",
    TRC20: "Tron (TRC20)",
    "DASH-MAINNET": "Dash",
    "DOGE-MAINNET": "Dogecoin",
    "DOT-MAINNET": "Polkadot",
    "EOS-MAINNET": "EOS",
    "ETC-MAINNET": "Ethereum Classic",
    ETHPOW: "EthereumPoW",
    ARBITRUM: "Arbitrum One",
    OPTIMISM: "Optimism",
    "FIL-MAINNET": "Filecoin",
    "FTM-MAINNET": "Fantom",
    SOLANA: "Solana",
    "LTC-MAINNET": "Litecoin",
    "LUNC-MAINNET": "Terra Classic",
    "MATIC-MAINNET": "MATIC(Polygon)",
    "NEAR-MAINNET": "NEAR Protocol",
    "SOL-MAINNET": "Solana",
    MATIC: "MATIC(Polygon)",
    "VET-MAINNET": "VeChain",
    "XLM-MAINNET": "Stellar Network",
    "XRP-MAINNET": "Ripple",
    "XTZ-MAINNET": "Tezos",
};
class AssetAPIImpl {
    constructor(apiKey) {
        this.apiKey = null;
        this.requestSigner = undefined;
        this.apiKey = apiKey;
        this.requestSigner = (0, trade_token_lib_1.acquireKeyResolver)().requestSigner;
    }
    cancelWithdraw(id) {
        let body = {
            exchange: this.apiKey.market,
            id: id,
        };
        return this.requestSigner.getSignRequest("POST", "/broker/cancel_withdraw", JSON.stringify(body)).pipe((0, operators_1.map)((result) => {
            return result.data;
        }));
    }
    fetchDepositWithdrawHistory(coin, type, startTime) {
        let body = {
            exchange: this.apiKey.market,
            coin: coin,
            type: type,
            start_time: startTime,
        };
        return this.requestSigner.getSignRequest("POST", "/broker/fill_fetch_record", JSON.stringify(body)).pipe((0, operators_1.map)((result) => {
            return result.data.map((item) => {
                return {
                    id: item.id,
                    txId: item.txid,
                    currency: item.currency,
                    timestamp: item.timestamp,
                    type: item.type === "deposit" ? "deposit" : "withdraw",
                    amount: item.amount,
                    fee: item.fee,
                    address: item.address,
                    tag: item.tag,
                    status: item.status,
                };
            });
        }));
    }
    fetchDepositWithdrawHistoryV2(coin, type, startTime) {
        let body = {
            exchange: this.apiKey.market,
            code: coin,
            tx_type: type.toUpperCase(),
            since: startTime,
            version: "v2",
        };
        const signRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/transactions/`;
        return trade_utils_lib_1.ObservableUtils.getWithTradeAuthV3(url, signRequestParam, body, undefined).pipe((0, operators_1.map)((result) => {
            return (result !== null && result !== void 0 ? result : []).map((item) => {
                return {
                    id: item.id,
                    txId: item.txid,
                    currency: item.currency,
                    timestamp: item.timestamp,
                    internal: item.internal,
                    type: item.type === "deposit" ? "deposit" : "withdraw",
                    amount: item.amount,
                    fee: item.fee.cost,
                    address: item.address,
                    tag: item.tag,
                    confirmations: item.confirmations,
                    statusInner: item.status,
                    status: DWUtils_1.DWUtils.convertState(item.status),
                    canCancel: item.status === TradeTypeDef_1.WithdrawRecordStatus.APPLIED || item.status === TradeTypeDef_1.WithdrawRecordStatus.SHORTAGE,
                    approvalReason: "reason" in item
                        ? item.reason
                        : item.status === TradeTypeDef_1.WithdrawRecordStatus.HICOIN_REJECTED
                            ? TradeTypeDef_1.WITHDRAW_REJECT_REASON.walletRejected
                            : undefined,
                    reasonInner: item.reason,
                };
            });
        }));
    }
    fetchVerifyCode(verifyCodeType) {
        let body = {
            exchange: this.apiKey.market,
        };
        let urlPath = "/broker/verify_code";
        if (verifyCodeType === TradeTypeDef_1.VerifyCodeType.call) {
            urlPath += "?type=voice";
        }
        return this.requestSigner.getSignRequest("POST", urlPath, JSON.stringify(body)).pipe((0, operators_1.map)(() => {
            return true;
        }));
    }
    static parseProtocolToDisplay(coinName, protocol = "") {
        return coinProtocols[`${coinName}-${protocol.toUpperCase()}`] || coinProtocols[protocol.toUpperCase()] || protocol;
    }
    static resolveDWCoins(item) {
        let limits = undefined;
        let deposit = undefined;
        let withdraw = undefined;
        let precision = undefined;
        let kyc = undefined;
        if ("limits" in item) {
            if ("deposit" in item.limits) {
                deposit = {
                    max: null,
                    daily: null,
                    min: item.limits.deposit.min ? Number(item.limits.deposit.min) : null,
                };
            }
            if ("withdraw" in item.limits) {
                withdraw = {
                    max: item.limits.withdraw.max ? Number(item.limits.withdraw.max) : null,
                    daily: item.limits.withdraw.daily_max ? Number(item.limits.withdraw.daily_max) : null,
                    min: item.limits.withdraw.min ? Number(item.limits.withdraw.min) : null,
                };
                kyc = {
                    max: item.limits.withdraw.kyc_max ? Number(item.limits.withdraw.kyc_max) : null,
                    daily: item.limits.withdraw.kyc_daily_max ? Number(item.limits.withdraw.kyc_daily_max) : null,
                    min: item.limits.withdraw.kyc_min ? Number(item.limits.withdraw.kyc_min) : null,
                };
            }
            if ("precision" in item) {
                precision = {
                    deposit: null,
                    withdraw: item.precision ? Number(item.precision) : null,
                };
            }
            limits = {
                deposit: deposit,
                withdraw: withdraw,
                precision: precision,
                kycWithdraw: kyc,
            };
        }
        return {
            display_name: item.display_name || item.name,
            coinName: item.name,
            currency: item.code,
            fee: item.fee,
            limits: limits,
            fullName: item.full_name,
            protocol: item.protocol,
            protocolDisplay: AssetAPIImpl.parseProtocolToDisplay(item.name, item.protocol),
            withdrawPrecision: Number(item.precision),
            supportDeposit: item.tx_type.includes("DEPOSIT"),
            supportWithdraw: item.tx_type.includes("WITHDRAW"),
            noReserve: "no_reserve" in item ? item.no_reserve : false,
            maintain: "maintain" in item ? item.maintain : false,
            tradeConfirmation: item.trade_confirmation,
            withdraw_memo: item.has_tag,
            deposit_enabled: item.deposit,
            withdraw_enabled: item.withdraw,
            contract_address: item.contract_address,
            wallet_type: item.wallet_type,
        };
    }
    requestAllBrokerCoins() {
        let body = {
            exchange: this.apiKey.market,
        };
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/get_coins`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost()["commonParam"]);
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, undefined, JSON.stringify(body), (resp) => {
            return resp;
        }).pipe((0, operators_1.map)((result) => {
            return result.data.map((item) => {
                return AssetAPIImpl.resolveDWCoins(item);
            });
        }));
    }
    requestAllBrokerCoinsV2() {
        let body = {
            exchange: this.apiKey.market,
        };
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/get_coins_v2`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost()["commonParam"]);
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, undefined, JSON.stringify(body), (resp) => {
            return resp;
        }).pipe((0, operators_1.map)((result) => {
            return result.data.map((item) => {
                return AssetAPIImpl.resolveDWCoins(item);
            });
        }));
    }
    requestCoinAddress(coin) {
        let body = {
            code: coin,
            exchange: this.apiKey.market,
        };
        const signRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/deposit_address/`;
        return trade_utils_lib_1.ObservableUtils.getWithTradeAuthV3(url, signRequestParam, body, undefined).pipe((0, operators_1.map)((result) => {
            return {
                address: result.address,
                currency: result.currency,
                tag: result.tag,
            };
        }));
    }
    withdraw(param) {
        let body = {
            exchange: this.apiKey.market,
            coin: param.coin,
            address: param.address,
            tag: param.tag,
            amount: param.amount,
            sms_code: param.sms_code,
            google_code: param.google_code,
            note: param.note,
        };
        return this.requestSigner.getSignRequest("POST", "/broker/withdraw", JSON.stringify(body)).pipe((0, operators_1.map)(() => {
            return true;
        }));
    }
    withdrawV2(param) {
        var _a, _b;
        let body = {
            exchange: this.apiKey.market,
            code: param.coin,
            address: param.address,
            tag: param.tag,
            amount: param.amount,
            google_code: (_a = param.google_code) !== null && _a !== void 0 ? _a : "",
            note: (_b = param.note) !== null && _b !== void 0 ? _b : "",
        };
        if (param.sms_code) {
            body["sms_code"] = param.sms_code;
            body["sms_code_id"] = param.sms_code_id;
        }
        if (param.voice_code) {
            body["voice_code"] = param.voice_code;
            body["voice_code_id"] = param.voice_code_id;
        }
        if (param.email_code) {
            body["email_code"] = param.email_code;
            body["email_code_id"] = param.email_code_id;
        }
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/withdraw/`;
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.map)((token) => {
            let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
            let headers = { Authorization: `Bearer ${token.awsToken}|${token.tradingToken}|` };
            return { url: urlWithCommonParam, headers };
        }))
            .pipe((0, operators_1.mergeMap)((getReqInfo) => {
            const { url, headers } = getReqInfo;
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(url, headers, JSON.stringify(body), (response) => response);
        }))
            .pipe((0, operators_1.map)((result) => {
            return true;
        }));
    }
    requestMoveRecords(coin) {
        let body = {
            coin: coin,
            exchange: this.apiKey.market,
        };
        const signRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/move_records/`;
        return trade_utils_lib_1.ObservableUtils.getWithTradeAuthV3(url, signRequestParam, body, undefined).pipe((0, operators_1.map)((result) => {
            return result.map((item) => {
                return {
                    id: item.request_id,
                    tag: item.move_tag,
                    status: item.move_status,
                    subAccountId: item.sub_account_id,
                    timestamp: item.time,
                    direction: item.direction,
                    currency: item.coin,
                    amount: new trade_utils_lib_1.SafeDecimal(item.amount ? item.amount : 0),
                };
            });
        }));
    }
    fetchMergeBalance() {
        let body = {
            exchange: this.apiKey.market,
        };
        return this.requestSigner.getSignRequest("POST", "/broker/merge_balance", JSON.stringify(body)).pipe((0, operators_1.mergeMap)((result) => {
            if (result.code === 0) {
                let balances = Object.keys(result.data).map((coin) => {
                    const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                        .getMarketSymbol(this.apiKey.market)
                        .find((item) => item.base === coin);
                    let coinInfo = result.data[coin];
                    return {
                        currency: coin,
                        available: coinInfo.total - coinInfo.frozen,
                        frozen: coinInfo.frozen,
                        balance: coinInfo.total,
                        currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                    };
                });
                return (0, rxjs_1.of)(balances.filter((obj) => {
                    return obj.currency !== "Cointype_NA";
                }));
            }
            else {
                throw result.message ? result.message : "cannot get balance";
            }
        }));
    }
    fetchPionexSpotBalance() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/balance/`;
        return this.requestSigner.getSignRequestV2("GET", url, undefined).pipe((0, operators_1.map)((result) => {
            var _a;
            const currencies = (_a = result.data.currencies) !== null && _a !== void 0 ? _a : {};
            const coinList = Object.keys(currencies);
            const spotBalance = coinList.map((coin) => {
                return {
                    balanceType: TradeTypeDef_1.BALANCE_TYPE.TRADE,
                    currency: coin,
                    available: currencies[coin].free,
                    currencyAlias: coin,
                    frozen: currencies[coin].used,
                    balance: currencies[coin].total,
                    btcPrice: 0,
                    btcChangePercent: 0,
                    usdPrice: 0,
                    usdChangePercent: 0,
                };
            });
            return {
                trade: spotBalance,
                swap: [],
                fund: [],
                debt: [],
            };
        }));
    }
    formatBalanceData(balanceData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        const result = balanceData;
        const prices = result.data.prices || {};
        let tradeAssets = [];
        let fundAssets = [];
        let debtAssets = [];
        let futureAssets = [];
        let manualAssets = [];
        // 基金
        if (result.data.fund && Array.isArray(result.data.fund)) {
            const fundBalance = result.data.fund;
            fundAssets = fundBalance.map((item) => {
                var _a, _b, _c, _d;
                const tmp = item.coin.split("_");
                return {
                    fundCode: item.coin,
                    fundCurrency: tmp[0],
                    fullName: tmp[0] === "BTC" ? "Bitcoin" : "Tether",
                    available: new trade_utils_lib_1.SafeDecimal(item.free),
                    frozen: new trade_utils_lib_1.SafeDecimal(item.frozen),
                    cost: new trade_utils_lib_1.SafeDecimal(item.cost || 0),
                    partSell: "part_sell" in item ? item.part_sell : false,
                    price: new trade_utils_lib_1.SafeDecimal(item.price || 0),
                    profit: new trade_utils_lib_1.SafeDecimal(item.total_profit),
                    usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[tmp[0]]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                    usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[tmp[0]]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                    btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[tmp[0]]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                    btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[tmp[0]]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
                };
            });
        }
        // 现货:手动+策略整合
        if (result.data.spot) {
            const { manual, strategy } = result.data.spot;
            let tradeBalance = {};
            if (manual && strategy) {
                // 整合 manual 和 strategy
                const manualCurrencies = (_a = manual.currencies) !== null && _a !== void 0 ? _a : {};
                const strategyCurrencies = (_b = strategy.currencies) !== null && _b !== void 0 ? _b : {};
                const manualAllCoins = Object.keys(manualCurrencies);
                const strategyAllCoins = Object.keys(strategyCurrencies);
                const spotAllCoins = Array.from(new Set([...manualAllCoins, ...strategyAllCoins]));
                spotAllCoins.map((coin) => {
                    const manualInfo = manualCurrencies[coin];
                    const strategyInfo = strategyCurrencies[coin];
                    tradeBalance[coin] = {};
                    tradeBalance[coin].total = new trade_utils_lib_1.SafeDecimal(manualInfo ? manualInfo.total : 0)
                        .add(new trade_utils_lib_1.SafeDecimal(strategyInfo ? strategyInfo.total : 0))
                        .toNumber();
                    tradeBalance[coin].free = new trade_utils_lib_1.SafeDecimal(manualInfo ? manualInfo.free : 0).toNumber();
                    tradeBalance[coin].used = new trade_utils_lib_1.SafeDecimal(manualInfo ? manualInfo.used : 0)
                        .add(new trade_utils_lib_1.SafeDecimal(strategyInfo ? strategyInfo.total : 0))
                        .toNumber();
                });
            }
            if (tradeBalance) {
                tradeAssets = Object.keys(tradeBalance)
                    .map((coin) => {
                    var _a, _b, _c, _d;
                    let coinInfo = tradeBalance[coin];
                    const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                        .getMarketSymbol(this.apiKey.market)
                        .find((item) => item.base === coin);
                    return {
                        currency: coin,
                        currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                        fullName: prices[coin] ? prices[coin].full_name : coin,
                        balanceType: "trade",
                        available: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                        frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                        balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                        usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                        usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                        btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                        btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
                    };
                })
                    .filter((obj) => {
                    return obj.currency !== "Cointype_NA";
                });
            }
        }
        // 借贷
        if ((_d = (_c = result.data.spot) === null || _c === void 0 ? void 0 : _c.debt) === null || _d === void 0 ? void 0 : _d.debts) {
            const debtBalance = result.data.spot.debt.debts;
            debtAssets = debtBalance.map((item) => {
                var _a, _b, _c, _d;
                const coin = item.coin;
                let coinInfo = item;
                const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                    .getMarketSymbol(this.apiKey.market)
                    .find((item) => item.base === coin);
                return {
                    currency: coin,
                    balanceType: TradeTypeDef_1.BALANCE_TYPE.DEBT,
                    currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                    total: new trade_utils_lib_1.SafeDecimal(coinInfo.principal || 0).add(coinInfo.interest).toNumber(),
                    principal: new trade_utils_lib_1.SafeDecimal(coinInfo.principal || 0).toNumber(),
                    interest: new trade_utils_lib_1.SafeDecimal(coinInfo.interest || 0).toNumber(),
                    fullName: prices[coin] ? prices[coin].full_name : coin,
                    usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                    usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                    btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                    btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
                };
            });
        }
        // 合约
        if (result.data.swap) {
            const futureBalance = result.data.swap.currencies;
            futureAssets = Object.keys(futureBalance).map((coin) => {
                var _a, _b, _c, _d, _e;
                const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                    .getMarketSymbol(this.apiKey.market)
                    .find((item) => item.base === coin);
                let coinInfo = futureBalance[coin];
                const available = new trade_utils_lib_1.SafeDecimal(coin === "USDT" ? (_a = result.data.swap) === null || _a === void 0 ? void 0 : _a.available_balance : coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free);
                return {
                    currency: coin,
                    currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                    fullName: prices[coin] ? prices[coin].full_name : coin,
                    balanceType: TradeTypeDef_1.BALANCE_TYPE.FUTURE,
                    available: available.toNumber(),
                    frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(available).toNumber(),
                    balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                    usdPrice: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.price_in_usd).toNumber(),
                    usdChangePercent: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.change_24h_in_usd).toNumber(),
                    btcPrice: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.price_in_btc).toNumber(),
                    btcChangePercent: new trade_utils_lib_1.SafeDecimal((_e = prices[coin]) === null || _e === void 0 ? void 0 : _e.change_24h_in_btc).toNumber(),
                };
            });
        }
        // manual 手动
        if ((_f = (_e = result.data.spot) === null || _e === void 0 ? void 0 : _e.manual) === null || _f === void 0 ? void 0 : _f.currencies) {
            const manualAsset = result.data.spot.manual.currencies;
            manualAssets = Object.keys(manualAsset).map((coin) => {
                var _a, _b, _c, _d;
                const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                    .getMarketSymbol(this.apiKey.market)
                    .find((item) => item.base === coin);
                let coinInfo = manualAsset[coin];
                return {
                    currency: coin,
                    currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                    fullName: prices[coin] ? prices[coin].full_name : coin,
                    balanceType: TradeTypeDef_1.BALANCE_TYPE.TRADE,
                    available: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                    frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                    balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                    usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                    usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                    btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                    btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
                };
            });
        }
        return {
            trade: tradeAssets,
            fund: fundAssets,
            debt: debtAssets,
            future: {
                totalFutureInfo: {
                    totalInitialMargin: new trade_utils_lib_1.SafeDecimal((_g = result.data.swap) === null || _g === void 0 ? void 0 : _g.total_initial_margin).toNumber(),
                    totalMaintMargin: new trade_utils_lib_1.SafeDecimal((_h = result.data.swap) === null || _h === void 0 ? void 0 : _h.total_maint_margin).toNumber(),
                    totalWalletBalance: new trade_utils_lib_1.SafeDecimal((_j = result.data.swap) === null || _j === void 0 ? void 0 : _j.total_wallet_balance).toNumber(),
                    totalUnrealizedProfit: new trade_utils_lib_1.SafeDecimal((_k = result.data.swap) === null || _k === void 0 ? void 0 : _k.total_unrealized_profit).toNumber(),
                    totalMarginBalance: new trade_utils_lib_1.SafeDecimal((_l = result.data.swap) === null || _l === void 0 ? void 0 : _l.total_margin_balance).toNumber(),
                    totalPositionInitialMargin: new trade_utils_lib_1.SafeDecimal((_m = result.data.swap) === null || _m === void 0 ? void 0 : _m.total_position_initial_margin).toNumber(),
                    totalOpenOrderInitialMargin: new trade_utils_lib_1.SafeDecimal((_o = result.data.swap) === null || _o === void 0 ? void 0 : _o.total_open_order_initial_margin).toNumber(),
                    totalCrossWalletBalance: new trade_utils_lib_1.SafeDecimal((_p = result.data.swap) === null || _p === void 0 ? void 0 : _p.total_cross_wallet_balance).toNumber(),
                    totalCrossInPnl: new trade_utils_lib_1.SafeDecimal((_q = result.data.swap) === null || _q === void 0 ? void 0 : _q.total_cross_un_pnl).toNumber(),
                    availableBalance: new trade_utils_lib_1.SafeDecimal((_r = result.data.swap) === null || _r === void 0 ? void 0 : _r.available_balance).toNumber(),
                    maxWithdrawAmount: new trade_utils_lib_1.SafeDecimal((_s = result.data.swap) === null || _s === void 0 ? void 0 : _s.max_withdraw_amount).toNumber(),
                    total: new trade_utils_lib_1.SafeDecimal((_t = result.data.total) === null || _t === void 0 ? void 0 : _t.swap_total_in_usd).toNumber(),
                },
                balances: futureAssets,
            },
            swap: [],
            assetExcludeBot: manualAssets,
            total: {
                total24hChangeUsdPercent: (_u = result.data.total) === null || _u === void 0 ? void 0 : _u.total_24h_change_in_usd,
                total24hChangeBtcPercent: (_v = result.data.total) === null || _v === void 0 ? void 0 : _v.total_24h_change_in_btc,
                totalBtc: (_w = result.data.total) === null || _w === void 0 ? void 0 : _w.total_in_btc,
                totalUsd: (_x = result.data.total) === null || _x === void 0 ? void 0 : _x.total_in_usd,
                fundTotalInUsd: new trade_utils_lib_1.SafeDecimal((_y = result.data.total) === null || _y === void 0 ? void 0 : _y.fund_total_in_usd).toNumber(),
                spotTotalInUsd: new trade_utils_lib_1.SafeDecimal((_z = result.data.total) === null || _z === void 0 ? void 0 : _z.spot_total_in_usd).toNumber(),
                futureTotalInUsd: new trade_utils_lib_1.SafeDecimal((_0 = result.data.total) === null || _0 === void 0 ? void 0 : _0.swap_total_in_usd).toNumber(),
            },
        };
    }
    parseProtocolToDisplay(coinName, protocol) {
        return AssetAPIImpl.parseProtocolToDisplay(coinName, protocol);
    }
}
exports.default = AssetAPIImpl;
